import { Formik } from "formik";
import React, {useState} from "react";
import { FiBriefcase, FiSave, FiTrash2, FiXCircle } from "react-icons/fi";

export const FeatureDrawer = ({close})=>{
    const [status] = useState(true)
    const bodyTag = document.getElementsByTagName('html')[0]; 
    let drawerValues = {}
    const id = drawerValues?._id

    const typeId = `${drawerValues?.type}-${id}-req`
    console.log('typeId:',typeId)
    React.useEffect( () => {
        if(status)
            bodyTag.classList.add('stop')
        else
            bodyTag.classList.remove('stop') 
    },[status]);

    const closeModal = (e) => {
        e.preventDefault()
        bodyTag.classList.remove('stop') 
        close();
    } 

    return status && typeId ?(
    <React.Fragment>
        <div className="user-edit-drawer">
         <Formik
                initialValues={{ 
                    count: drawerValues?.count , 
                    type: drawerValues?.reqType,
                  
                 }}
                onSubmit={(values, { setSubmitting }) => {
                  
                }}
                >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit}>
                            <div className="user-heading">
                                    <div></div>
                                    <div>
                                        <a href="##">
                                            <FiTrash2 />
                                        </a>
                                        <a href="##">
                                            <FiSave />
                                        </a>
                                        <a href="##"  onClick={(e)=>{
                                            
                                        }} >
                                            <FiXCircle  />
                                        </a>
                                    </div>
                                </div>

                                <ul>
                                    <li className="flex">
                                        <div className="icon">
                                            <FiBriefcase />
                                        </div>
                                        <input 
                                            type="number" 
                                            placeholder="count"
                                            name="count"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.count}
                                        
                                        />
                                        {/*
                                        */}
                                    </li>
                                
 
                                    <li className="flex">
                                        <div>
                                            <p 
                                                style={{color:'red', cursor:'point'}}
                                                onClick={()=>{
                                                }}
                                            >
                                                Remove 
                                            </p>
                                        </div>
                                        <div>
                                            <button type="submit" className="button primary">Apply</button>
                                        </div>
                                    </li>
                                </ul>
                       
 
                        </form>
                    )}
        </Formik>
        <ul>
        <li className="flex">
             <div className="profile_component">
             </div>
         </li>
                              
        </ul>
        </div>
        <div 
             className="overlay"  
             onClick={(e)=> closeModal(e)}
         >
         </div>
    </React.Fragment>
    ) : <React.Fragment></React.Fragment>
}

export default FeatureDrawer
 